export const NAME = 'authentication';
export const LOCALSTORAGE_KEY_AUTH_TOKEN = 'token';
export const LOCALSTORAGE_KEY_AUTH_TIMESTAMP = 'authTimestamp';
export const LOCALSTORAGE_KEY_AUTH_ISAUTHENTICATED = 'isAuthenticated';

// Origine de l'authentification : apposée par le back sur l'URL de succès
// (?tk=xxx&provider=...), relayée dans le body de /auth/login et renvoyée
// en écho dans l'AuthDto
export const PROVIDER_FNAC = 'fnac';
export const PROVIDER_DARTY = 'darty';

// Code d'erreur générique du contrat SSO (SSOAuthenticationConstants.LOGIN_FAILED côté back),
// porté par ?error= sur /connexion pour ouvrir la modale d'erreur
export const SSO_ERROR_LOGIN_FAILED = '0';

// Efface l'erreur globale des formulaires login/register (quand elle est déjà
// affichée ailleurs, ex. dans la modale d'erreur de connexion)
export const CLEAR_AUTHENTICATION_ERROR = 'CLEAR_AUTHENTICATION_ERROR';



// WEBPACK FOOTER //
// ./src/services/authentication/constants.js